module.exports = __webpack_public_path__ + "img/step21_a_stand_power_install_and_fix_right_adaptor.a1550702.png";